import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getStudents, createStudent, deleteStudent, Student } from "../api/client";

export default function Students() {
  const [students, setStudents] = useState<Student[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", email: "", notes: "" });

  const load = () => getStudents(false).then((r) => setStudents(r.data));
  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!form.name.trim()) return;
    await createStudent(form);
    setForm({ name: "", phone: "", email: "", notes: "" });
    setShowModal(false);
    load();
  };

  const handleDelete = async (id: string, name: string) => {
    if (!window.confirm(`Delete ${name}?`)) return;
    await deleteStudent(id);
    load();
  };

  return (
    <div>
      <div className="toolbar">
        <h2>Students</h2>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Add Student</button>
      </div>

      <div className="table-container">
        {students.length === 0 ? (
          <div className="empty">No students yet. Add one to get started.</div>
        ) : (
          <table>
            <thead>
              <tr><th>Name</th><th>Phone</th><th>Email</th><th>Classes</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {students.map((s) => (
                <tr key={s.id}>
                  <td><Link to={`/students/${s.id}`} style={{ color: "var(--accent)", fontWeight: 500 }}>{s.name}</Link></td>
                  <td>{s.phone || "-"}</td>
                  <td>{s.email || "-"}</td>
                  <td>{s.classes?.map((c) => c.name).join(", ") || "-"}</td>
                  <td><span className={`badge ${s.active ? "present" : "absent"}`}>{s.active ? "Active" : "Inactive"}</span></td>
                  <td><button className="btn btn-danger btn-sm" onClick={() => handleDelete(s.id, s.name)}>Delete</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Add Student</h3>
            <div className="form-group">
              <label>Name *</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Phone</label>
                <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              </div>
            </div>
            <div className="form-group">
              <label>Notes</label>
              <textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleCreate}>Add Student</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
